import { useMemo, useState } from 'react';

import { useCurrentEventQuery } from '../../../event/hooks/useCurrentEventQuery';
import { useCurrentUserQuery } from '../../../user/hooks/useCurrentUserQuery';
import { useCarpoolTripsQuery } from '../../hooks/useCarpoolTripsQuery';

export const useCarpool = () => {
  const [selectedTripId, setSelectedTripId] = useState<string | null>(null);
  const [isCreateTripDrawerOpen, setIsCreateTripDrawerOpen] =
    useState<boolean>(false);
  const { data: currentEventData } = useCurrentEventQuery();
  const { data: currentUserData } = useCurrentUserQuery();

  const currentEvent = currentEventData?.currentEvent ?? null;
  const currentUser = currentUserData?.currentUser ?? null;
  const { data: carpoolTripsData } = useCarpoolTripsQuery(
    currentEvent?.id ?? null,
  );

  const trips = useMemo(
    () => carpoolTripsData?.carpoolTrips ?? [],
    [carpoolTripsData?.carpoolTrips],
  );

  const joinedTrip = useMemo(
    () =>
      trips.find(
        (trip) =>
          trip.driver.id === currentUser?.id ||
          trip.passengers.some((passenger) => passenger.id === currentUser?.id),
      ) ?? null,
    [currentUser?.id, trips],
  );

  const selectedTrip = useMemo(
    () => trips.find((trip) => trip.id === selectedTripId) ?? null,
    [selectedTripId, trips],
  );

  const canCreateTrip =
    (currentEvent?.hasPaidTicket ?? false) && joinedTrip === null;
  const isStaff =
    (currentUserData?.currentUser?.isStaff ?? false) ||
    (currentUserData?.currentUser?.isAdmin ?? false);

  const onOpenTrip = (tripId: string) => {
    setSelectedTripId(tripId);
  };

  const onCloseTrip = () => {
    setSelectedTripId(null);
  };

  const onOpenCreateTripDrawer = () => {
    setIsCreateTripDrawerOpen(true);
  };

  const onCloseCreateTripDrawer = () => {
    setIsCreateTripDrawerOpen(false);
  };

  return {
    canCreateTrip,
    currentEvent,
    currentUser,
    isCreateTripDrawerOpen,
    isStaff,
    joinedTrip,
    onCloseCreateTripDrawer,
    onCloseTrip,
    onOpenCreateTripDrawer,
    onOpenTrip,
    selectedTrip,
    trips,
  };
};
